import { z } from 'zod';

export const formSchema = z.object({
  ma_tc_thue: z.string().nonempty('Mã tính chất thuế là bắt buộc'),
  ten_tc_thue: z.string().nonempty('Tên tính chất thuế là bắt buộc'),
  ten_tc_thue2: z.string().optional(),
  status: z.string().optional()
});

export type FormValues = z.infer<typeof formSchema>;

export const initialValues: FormValues = {
  ma_tc_thue: '',
  ten_tc_thue: '',
  ten_tc_thue2: '',
  status: '1'
};
